import React, { Component } from 'react';
import { manuallyUpdateStickyHeaderWidth } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/magic';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from '../styles.module.css';
import type { Props } from './types';

// eslint-disable-next-line jira/react/no-class-components
class StickyHeaderCell extends Component<Props> {
	shouldComponentUpdate(nextProps: Props) {
		if (this.props.width !== nextProps.width && this.props.containerId) {
			manuallyUpdateStickyHeaderWidth(this.props.containerId, nextProps.width);
		}
		return !nextProps.isDragging;
	}

	render() {
		const { containerId, isCollapsedField } = this.props;
		if (isCollapsedField === true) return null;
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		return <div id={containerId} className={styles.portalContainer} />;
	}
}

export default StickyHeaderCell;
